import { createStore } from "vuex";
import axios from "axios";

export default createStore({
  state: {
    lang: localStorage.getItem("lang") || "ru",
    auth: localStorage.getItem("access_token") ? true : false,
    role: localStorage.getItem("user_role") || '',
    expired: localStorage.getItem("guest_expired") || '',
    user_id: null,
    user_name: null,
    curator_id: null,
    showLoader: false,
    user: {},
    cdn: 'https://admin.mentorme.kz/',
    isBlocked: false,
    hasApprovedPrograms: null,
    sidebarCollapsed: false,
  },

  getters: {
    userInfo(state) {
      return state.user?.data?.data || false;
    },
  },

  mutations: {
    SET_AUTH(state, auth) {
      state.auth = auth;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_ROLE(state, role) {
      state.role = role;
      localStorage.setItem("user_role", role);
    },
    SET_USER_ID(state, id) {
      state.user_id = id;
    },
    SET_USER_NAME(state, name) {
      state.user_name = name;
    },
    SET_CURATOR_ID(state, id) {
      state.curator_id = id;
    },
    SET_SHOW_LOADER(state, value) {
      state.showLoader = value;
    },
    SET_BLOCK(state, value) {
      state.isBlocked = value
    },
    SET_EXPIRED(state, value) {
      state.expired = value
      localStorage.setItem("guest_expired", value)
    },
    SET_HAS_APPROVED_PROGRAMS(state, value) {
      state.hasApprovedPrograms = value;
    },
    SET_SIDEBAR_COLLAPSED(state, value) {
      state.sidebarCollapsed = value;
      if (typeof document !== 'undefined') {
        document.body.classList.toggle('sidebar-collapsed', value);
      }
    },
  },

  actions: {
    logoutUser({ commit }) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_role");
      localStorage.removeItem("guest_expired");
      commit("SET_USER", {});
      commit("SET_AUTH", false);
      commit("SET_ROLE", '');
      commit("SET_EXPIRED", '')
      commit("SET_HAS_APPROVED_PROGRAMS", null);
    },

    toggleBlock({commit}, value) {
      commit('SET_BLOCK', value)
    },
    navigateToPay() {
      const waLink = "https://wa.link/t6mtq4";
      window.open(waLink, "_blank");
    },

    async requestUser({ commit, dispatch }) {
      try {
        const res = await axios.get(`/platform/me`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });

        // const res = await axios.get(`http://localhost:8080/api/platform/me`, {
        //   headers: {
        //     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        //   },
        // });

        const userData = res.data.data;

        commit("SET_USER", res);
        commit("SET_AUTH", true);
        commit("SET_USER_ID", userData.id);
        commit("SET_USER_NAME", userData.name);

        let role = '';
        let expired = '';
        switch (userData.role.name) {
          case 'client':
            commit("SET_CURATOR_ID", userData.curator_id);
            role = 'user';
            break;
          case 'guest':
            role = userData.role.name;
            expired = userData.guest_expires_at;
            break;
          case 'curator':
          case 'expert':
          case 'supervisor':
          case 'chief':
            role = userData.role.name;
            break;
        }
        commit("SET_ROLE", role);
        commit("SET_EXPIRED", expired);

        if (role === "user") {
          await dispatch("fetchUserAdmissions");
        } else {
          commit("SET_HAS_APPROVED_PROGRAMS", null);
        }
      } catch (error) {
        console.error("requestUser failed:", error);
        localStorage.removeItem("access_token");
        localStorage.removeItem("user_role");
        localStorage.removeItem("guest_expired");
        commit("SET_USER", {});
        commit("SET_AUTH", false);
        commit("SET_ROLE", '');
        commit("SET_EXPIRED", '')
        commit("SET_HAS_APPROVED_PROGRAMS", null);

        throw error;
      }
    },

    toggleSidebar({ commit, state }) {
      commit('SET_SIDEBAR_COLLAPSED', !state.sidebarCollapsed);
    },

    async fetchUserAdmissions({ commit }) {
      try {
        const res = await axios.get(`/platform/client/user-admissions`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        const admissions = Array.isArray(res.data?.data) ? res.data.data : [];
        commit("SET_HAS_APPROVED_PROGRAMS", admissions.length > 0);
      } catch {
        commit("SET_HAS_APPROVED_PROGRAMS", false);
      }
    },
  },

  modules: {
    // можно добавить модули позже
  }
});